import React from 'react';
import { ShieldCheck, Bot, Users, Target } from 'lucide-react';

const miniCases = [
    {
        icon: <ShieldCheck className="w-8 h-8 text-primary-light dark:text-primary-dark" />,
        title: "Automatyzacja Reklamacji E-commerce",
        problem: "Ręczna obsługa 50+ zgłoszeń reklamacyjnych dziennie, zajmująca 4 godziny pracy specjalisty.",
        system: "Wdrożenie SmartClaim AI do automatycznej kategoryzacji, analizy i generowania odpowiedzi.",
        result: "Czas obsługi ↓ o 75%, satysfakcja klienta ↑ o 25% w ciągu 30 dni."
    },
    {
        icon: <Bot className="w-8 h-8 text-primary-light dark:text-primary-dark" />,
        title: "Content Engine AI",
        problem: "Brak czasu i pomysłów na regularne tworzenie wartościowych treści na social media.",
        system: "Uruchomienie ContentFlow AI, które generowało 3 angażujące posty branżowe tygodniowo.",
        result: "Zasięgi organiczne ↑ o 150%, zaangażowanie ↑ o 80% w ciągu 30 dni."
    },
    {
        icon: <Users className="w-8 h-8 text-primary-light dark:text-primary-dark" />,
        title: "Chatbot do Pozyskiwania Leadów",
        problem: "Wysoki współczynnik odrzuceń na stronie z cennikiem; klienci opuszczali stronę bez zostawienia kontaktu.",
        system: "Implementacja proaktywnego Agenta AI, który inicjował rozmowę i oferował darmową konsultację.",
        result: "Liczba pozyskanych leadów ↑ o 300% (z 2 do 8 dziennie) w ciągu 30 dni."
    },
    {
        icon: <Target className="w-8 h-8 text-primary-light dark:text-primary-dark" />,
        title: "Automatyczne Pozyskiwanie Leadów B2B",
        problem: "Zespół sprzedaży poświęcał 50% czasu na ręczne wyszukiwanie kontaktów, zamiast na sprzedaż.",
        system: "Wdrożenie BiznesFinder AI, które skanuje publiczne rejestry i dostarcza zweryfikowane kontakty.",
        result: "Baza 500+ nowych leadów w 1 tydzień. Czas na research ↓ o 90%."
    }
];

const MiniCaseCard: React.FC<typeof miniCases[0]> = ({ icon, title, problem, system, result }) => (
    <div className="bg-content-light dark:bg-content-dark p-6 rounded-2xl border border-border-light dark:border-border-dark flex flex-col">
        <div className="flex items-center mb-4">
            {icon}
            <h3 className="text-lg font-bold ml-4">{title}</h3>
        </div>
        <dl className="text-sm space-y-3 flex-grow">
            <div>
                <dt className="font-semibold text-text-primary-light dark:text-text-primary-dark">Problem:</dt>
                <dd className="text-text-secondary-light dark:text-text-secondary-dark">{problem}</dd>
            </div>
            <div>
                <dt className="font-semibold text-text-primary-light dark:text-text-primary-dark">System:</dt>
                <dd className="text-text-secondary-light dark:text-text-secondary-dark">{system}</dd>
            </div>
        </dl>
        <div className="mt-4 pt-4 border-t border-border-light dark:border-border-dark">
             <p className="font-bold text-lg text-primary-light dark:text-primary-dark text-center">{result}</p>
        </div>
    </div>
);

export const MiniCaseStudies: React.FC = () => {
    return (
        <div className="container mx-auto px-4">
            <div className="text-center mb-12">
                <h2 className="text-3xl font-bold">Wyniki w 30 dni</h2>
                <p className="text-lg text-text-secondary-light dark:text-text-secondary-dark mt-4 max-w-2xl mx-auto">
                    Konkretne problemy, wdrożone systemy i mierzalne rezultaty osiągnięte w pierwszym miesiącu współpracy.
                </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                {miniCases.map((miniCase, index) => (
                    <MiniCaseCard key={index} {...miniCase} />
                ))}
            </div>
        </div>
    );
};